import React, { useState } from 'react';
import { signUp } from 'aws-amplify/auth';

const SignupModal = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // --- Estilos ---
    const modalOverlayStyle = {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)', display: 'flex',
        justifyContent: 'center', alignItems: 'center', zIndex: 2000,
    };

    const modalContentStyle = {
        backgroundColor: '#fff', padding: '35px', borderRadius: '12px',
        maxWidth: '400px', width: '90%', position: 'relative',
        boxShadow: '0 10px 25px rgba(0,0,0,0.3)', textAlign: 'center'
    };

    const inputStyle = {
        marginBottom: '12px', padding: '12px', width: '100%',
        boxSizing: 'border-box', border: '1px solid #ddd', borderRadius: '6px',
        fontSize: '14px'
    };

    // --- Lógica ---
    const handleSignup = async (e) => {
        e.preventDefault();
        setError('');

        // 1. Validar que las contraseñas coincidan
        if (password !== confirmPassword) {
            setError("⚠️ Las contraseñas no coinciden.");
            return;
        }

        // 2. Validar longitud mínima (estándar de Cognito)
        if (password.length < 8) {
            setError("⚠️ La contraseña debe tener al menos 8 caracteres.");
            return;
        }

        setLoading(true);
        try {
            const {  userId } = await signUp({
                username: email,
                password,
                options: {
                    userAttributes: { email }
                }
            });
            
            console.log("Registro iniciado:", userId);
            alert("¡Registro exitoso! Por favor revisa tu correo para el código de verificación.");
            onClose(); // Cerramos el modal para que el usuario verifique
        } catch (err) {
            console.error("Error en registro:", err);
            setError(err.message || "Ocurrió un error al crear la cuenta.");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div style={modalOverlayStyle} onClick={onClose}>
            <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
                <button onClick={onClose} style={{position: 'absolute', top: '15px', right: '15px', background: 'none', border: 'none', fontSize: '1.5em', cursor: 'pointer'}}>&times;</button>
                
                <h2 style={{color: '#333', marginBottom: '10px'}}>📝 Crear Cuenta</h2>
                <p style={{fontSize: '13px', color: '#666', marginBottom: '20px'}}>Únete a la plataforma de Giovanni Scarvaci</p>
                
                <form onSubmit={handleSignup}>
                    <input 
                        type="email" placeholder="Correo Electrónico" required style={inputStyle}
                        value={email} onChange={(e) => setEmail(e.target.value)}
                    />
                    <input 
                        type="password" placeholder="Contraseña (mín. 8 caracteres)" required style={inputStyle}
                        value={password} onChange={(e) => setPassword(e.target.value)}
                    />
                    <input 
                        type="password" placeholder="Repetir Contraseña" required style={inputStyle}
                        value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                    />

                    {error && <p style={{color: '#d93025', fontSize: '12px', marginBottom: '10px', fontWeight: 'bold'}}>{error}</p>}

                    <button 
                        type="submit" 
                        disabled={loading}
                        style={{
                            padding: '12px', backgroundColor: loading ? '#ccc' : '#D4AF37', 
                            color: 'white', border: 'none', borderRadius: '6px', 
                            cursor: 'pointer', width: '100%', fontWeight: 'bold', fontSize: '16px'
                        }}
                    >
                        {loading ? "Registrando..." : "Registrarse Ahora"}
                    </button>
                </form>

                <p style={{marginTop: '20px', fontSize: '13px', color: '#555'}}>
                    ¿Ya tienes una cuenta? <span style={{color: '#D4AF37', cursor: 'pointer', fontWeight: 'bold'}} onClick={onClose}>Inicia Sesión</span>
                </p>
            </div>
        </div>
    );
};

export default SignupModal;